import * as angular from 'angular';
import * as moment from 'moment';
import * as _ from 'lodash';

import { ILoggerService, IwidgetIntervalHelperService, IGroupTagsService } from '../../../services';
import { Group, IValueViewModel, GroupNameDto, ComponentDefinition } from '../../../models';

class WtAcquisitionModalContoller implements angular.IComponentController {
    beginDate: string;
    endDate: string;
    isRefreshPrevented: boolean = true;
    items: any[];
    modalId: string;
    range: any;
    validation: any;

    static $inject = [
        'widgetIntervalHelperService',
        'groupTagsService',
        'loggerService'
    ];

    constructor(
        private _widgetIntervalHelperService: IwidgetIntervalHelperService,
        private _groupTagsService: IGroupTagsService,
        private _loggerService: ILoggerService) {
    }

    createAcquisitionTask(force: boolean = false) {
        let beginDate = moment(this.beginDate).toISOString();
        let endDate = moment(this.endDate).toISOString();
        const updatedInterval = this._widgetIntervalHelperService.getInterval(beginDate, endDate, {
            isEndDateIncluded: false,
            minPeriod: undefined,
            maxPeriod: undefined
        });
        beginDate = updatedInterval.beginMoment.toISOString();
        endDate = updatedInterval.endMoment.toISOString();

        const guids = this.items.map(d => d.guid);
        this._groupTagsService
            .acquire(guids, beginDate, endDate, force)
            .then(data => {
                if (!force && data !== undefined && isNaN(data.length)) {
                    this.validation = data;
                    $(`#${this.modalId}_confirm`).modal('show');
                } else {
                    this._loggerService.logSuccess('Acquisition started.');
                }
            })
            .catch(() => {
                this._loggerService.logError('Failed to start acquisition.');
            });
        return false;
    }

    multipleFrequencies(): any[] {
        return this.items ? this.items.filter(i => this.tagHasMultipleFrequencies(i)) : [];
    }

    private tagHasMultipleFrequencies(tag: IValueViewModel): boolean {
        let result = false;

        if (tag && tag.groupList && tag.groupList.length > 1) {
            const first = tag.groupList[0];
            result = _.some(tag.groupList, g => !this.groupHasSameFrequency(first, g));
        }

        return result;
    }

    private groupHasSameFrequency(first: Group | GroupNameDto, second: Group | GroupNameDto): boolean {
        return first.frequency.interval === second.frequency.interval
            && first.frequency.intervalTimeUnit === second.frequency.intervalTimeUnit;
    }
}

export const WtAcquisitionModal: ComponentDefinition = {
    componentId: 'wtAcquisitionModal',
    template: require('./acquisitionModal.component.html'),
    controller: WtAcquisitionModalContoller,
    controllerAs: 'vm',
    bindings: {
        items: '=',
        range: '=?',
        modalId: '@'
    }
};